import { NewsProvider } from './../../providers/news/news';
import { News } from './../../models/News';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the NewsLinkComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'news-link',
  templateUrl: 'news-link.html'
})
export class NewsLinkComponent {
  @Input('news') news: News;

  constructor(public newsCtrl: NewsProvider) {

  }

  getDate(date: number){
    return date * 1000;
  }
}



// WEBPACK FOOTER //
// ./src/components/news-link/news-link.ts